export const handleSubscribe = async (
  onSending: (arg0: boolean) => void,
  participantAPI: { subscribeToNewsletters: (arg0: { userId: string }) => any },
  handleSuccess: () => void,
  handleClose: () => void,
  getParticipant: () => void,
  handleError: () => void,
  id: string,
) => {
  onSending(true)
  const result = await participantAPI.subscribeToNewsletters({ userId: id })
  const { status } = result

  if (status == 200) {
    handleSuccess()
    onSending(false)
    handleClose()
    getParticipant()
  } else {
    handleError()
    onSending(false)
    handleClose()
  }
}
